import React, { useContext } from 'react';
import ReactTooltip from 'react-tooltip';
import styles from './AddressSelector.module.css';
import stylesTooltip from '../../../../containers/Payment/Payment.module.css';
import PaymentContext from '../../../../context/Payment/Context';
import data from './data';

const AddressSelector = () => {
  const paymentContext = useContext(PaymentContext);
  const { address, showCloseAddressModal, hasAddress } = paymentContext;
  const disabledAddress = address.ChangePaymentType;
  const { defaultText } = data;

  return (
    <button
      id="Check_AddressSelector_SelectAddress"
      type="button"
      onClick={() => {
        if (!disabledAddress) {
          showCloseAddressModal(true);
        }
      }}
      className={styles.container}
      data-tip
      data-for="tooltip-error-address"
      style={disabledAddress ? { cursor: 'no-drop' } : { }}
    >
      <ReactTooltip
        place="top"
        id="tooltip-error-address"
        disable={!disabledAddress}
        effect="solid"
        offset="{'left': -125}"
        className={stylesTooltip.customTooltipAddress}
        backgroundColor="#212121"
      >
        No es posible modificar la dirección una vez realizada una orden
      </ReactTooltip>
      {hasAddress ? (
        <>
          <div className={styles.containerAddress}>
            <p className={styles.titleAddress}>
              {address.Street}
              {' '}
              {address.Address_Number}
            </p>
            <p className={styles.text}>
              {address.Neighborhood}
              ,
              {' '}
              {address.Zip_Code}
              ,
              {' '}
              {address.State[0]}
            </p>
          </div>
          <p className={styles.Add_address}>Editar</p>
        </>
      ) : (
        <>
          <p className={styles.text}>{defaultText}</p>
          <p className={styles.Add_address}>Agregar</p>
        </>
      )}
    </button>
  );
};

export default AddressSelector;
